import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_RESTAURANT_STATUSES from "./default";
import { RESTAURANT_STATUS_ORDER, type RestaurantStatus } from "./options";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (
  property: keyof FilterActionTypes<RestaurantStatusesModel>,
) =>
  createLogEffect<RestaurantStatusesModel>(
    "RESTAURANT_STATUSES",
    property,
    false,
  );

function normaliseSelection(
  selected: Set<RestaurantStatus>,
): RestaurantStatus[] {
  return RESTAURANT_STATUS_ORDER.filter((s) => selected.has(s));
}

export type RestaurantStatusesModel = {
  value: RestaurantStatus[];
  valueOnChange: LogEffect<RestaurantStatusesModel>;
  set: Action<RestaurantStatusesModel, RestaurantStatus[]>;
  toggle: Action<RestaurantStatusesModel, RestaurantStatus>;
  reset: Action<RestaurantStatusesModel>;
};

const restaurantStatusesModel: RestaurantStatusesModel = {
  value: [...DEFAULT_RESTAURANT_STATUSES],
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    const normalised = normaliseSelection(new Set(payload));
    const next =
      normalised.length > 0 ? normalised : [...DEFAULT_RESTAURANT_STATUSES];
    if (state.value.join() !== next.join()) {
      state.value = next;
    }
  }),
  toggle: action((state, payload) => {
    const selected = new Set(state.value);
    if (selected.has(payload)) {
      selected.delete(payload);
    } else {
      selected.add(payload);
    }
    const normalised = normaliseSelection(selected);
    state.value =
      normalised.length > 0 ? normalised : [...DEFAULT_RESTAURANT_STATUSES];
  }),
  reset: action((state) => {
    state.value = [...DEFAULT_RESTAURANT_STATUSES];
  }),
};

export default restaurantStatusesModel;
